<template>
  <div class="row head_block" style="margin:0px;padding:0px;height:74px">
       <slot name="header"></slot>
  </div>
</template>
<script>
import NavigationMenu from "@/components/NavigationMenu";
	
export default {
    data(){
        return{

        }
    },
    components:{
       NavigationMenu 
    },
    computed:{
      openDrawer:{
        set(val){
          this.$store.state.showNavigator = val
        },
        get(){
          return this.$store.state.showNavigator
        }
      }
    }
}
</script>